




















import { Component, Prop, Vue } from "vue-property-decorator";
import Spot from "@/models/Spot";

@Component({})
export default class AggregationMode extends Vue {
  @Prop({ default: () => [] }) readonly selected?: Spot[];

  get selectedNumber(): number {
    return this.selected?.length || 0;
  }

  cancel() {
    this.$emit("cancel");
  }

  aggregate() {
    this.$emit("aggregate");
  }
}
